import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@/scss/vuetify/overrides.scss'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify);

const theme = {
    primary: '#1e88e5',
    info: '#1e88e5',
    success: '#21c1d6',
    accent: '#fc4b6c',
    default: '#563dea'
}

export default new Vuetify({
    theme: {
        themes: {
          dark: theme,
          light: theme
        },
      },
      icons: {
        iconfont: 'mdi'
    }
})
